import { createFileRoute, redirect } from '@tanstack/react-router'
import { homeScope } from '~/features/home/queries'
import { mySettlementsQuery, selfAllowed } from '~/features/self/queries'
import { SettlementsPage } from '~/features/self/SettlementsPage'

export const Route = createFileRoute('/_app/ich/abrechnungen')({
  beforeLoad: async ({ context }) => {
    if (!(await selfAllowed(context.queryClient))) throw redirect({ to: '/' })
  },
  loader: async ({ context }) => {
    const scope = await homeScope(context.queryClient)
    if (scope) await context.queryClient.ensureQueryData(mySettlementsQuery(scope.teamId, scope.season)).catch(() => undefined)
  },
  component: SettlementsPage,
})
